import { Inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { from, Observable, throwError } from 'rxjs';
import { catchError, filter, mergeMap, switchMap, takeUntil } from 'rxjs/operators';
import { User } from 'src/app/shared/models/user';
import { AuthStore } from 'src/app/stores/auth.store';
import { get, includes, tap } from 'lodash';
import { AbstractComponent } from '../shared/components/abstract-component';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AuthService } from '../services/auth.service';
import { DpopTokenService } from '../services/dpop-token.service';
import { AppConfigService } from '../services/app-config.service';
import { IAppConfig } from '../shared/interfaces/app-config';
import { Route, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class HeaderInterceptor extends AbstractComponent implements HttpInterceptor {

  constructor(private authStore: AuthStore,
    private dpopTokenService: DpopTokenService,
    private appConfigService: AppConfigService,
    private router: Router,
  ) {
    super();
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const config: IAppConfig = this.appConfigService.getConfig();
    if (includes(request.url, 'config.json')) return next.handle(request);
    if (request.url.startsWith('https://localhost')) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer  ${this.authStore.getAccessToken()}`,
          Env: get(config, 'environment'),
        },
      });
    } else {
      if (this.authStore.isAuthenticated()) {
        const token = this.authStore.authorizationHeaderValue();
        request = request.clone({
          setHeaders: {
            jwt: this.authStore.getAccessToken() ?? '',
            dpop: this.dpopTokenService.generateDpop(request.url, request.method) ?? '',
            Authorization: token,
            Env: get(config, 'environment'),
          },
        });
      } else {
        if (request.url.indexOf('/token') > -1) {
          request = request.clone({
            setHeaders: {
              'Content-Type': 'application/x-www-form-urlencoded',
              dpop: this.dpopTokenService.generateAuthDpop(request.url.trim(), request.method) ?? '',
              Env: get(config, 'environment'),
            },
          });
        }
      }
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          // Redirect to login page on 401
          this.router.navigate(['/notauthorized']);
        }
        return throwError(() => error); // Re-throw the error for further handling if needed
      }));
  }

  override afterOnDestroy(): void {
    // afterOnDestroy
  }
}
